import { Link } from 'ui/links';

export const AlertsCaption = () => {
  return (
    <>
      A notification will be triggered if this campaign meets any of the alert criteria. To edit
      your alerts, visit{' '}
      <Link size="caption" data-test="alert-settings-link" href="/settings/alerts/campaigns">
        Alert Settings
      </Link>
      .
    </>
  );
};
